<script setup>
import { events, fetchEventsFromWordpress } from "@/Mixins/FetchesEventsFromWordpress"
import { ref, computed, onMounted } from 'vue'
import moment from 'moment';

import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import CalendarIcon from '@/icons/CalendarIcon'

onMounted(() => {
	fetchEventsFromWordpress()
	.then(() => {
		hasFetched.value = true
	})
})

const hasFetched = ref(false)

const nextEvent = computed(() => {
	if(events.value.length === 0) return null

	return events.value.filter(event => moment(event.start_date).isAfter(moment()))[0]
})

</script>

<template>
	<BlockLoader class="h-64 w-full" v-if="!hasFetched" />
	<DashboardStatsUserCard
		:icon=CalendarIcon
		v-else
		:href="route('dashboard.events.index')"
		linkText="View All Upcoming Events"
	>
		<div class="flex flex-col">
			<Heading size="4" class="text-center">Next Event</Heading>

			<div class="flex flex-col" v-if="!nextEvent">
				<div class="text-center mt-1">
					<h1 class="font-bold leading-4">No Upcoming Events</h1>
				</div>
			</div>

			<div class="flex flex-col" v-else>
				<div class="text-center mt-1">
					<h1 class="font-bold leading-4">{{ nextEvent.title }}</h1>
					<p class="text-sm mb-4">{{ moment(nextEvent.start_date).format("DD MMM YYYY") }}</p>
					
					<a :href="nextEvent.url" class="inline-flex no-child-events no-underline">
						<Button
							color="blue"
						>
							Book Now
						</Button>
					</a>
				</div>
			</div>
		</div>

		<template #footer>
			<Button
				color="blue"
				variant="link"
				href="/events"
			>
				View Upcoming Events
			</Button>
		</template>
	</DashboardStatsUserCard>
</template>